import { render, staticRenderFns } from "./AromaReportShare.vue?vue&type=template&id=33041e0b&scoped=true"
import script from "./AromaReportShare.vue?vue&type=script&lang=js"
export * from "./AromaReportShare.vue?vue&type=script&lang=js"
import style0 from "./AromaReportShare.vue?vue&type=style&index=0&id=33041e0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33041e0b",
  null
  
)

export default component.exports